import * as models from '../../../../models'
import { Inheritance } from '../../inheritance'
import { type Context, ForRecords, type Node } from '../node'

/**
 * TODO: explain
 */
export function determineIfResultsShouldBeSingleton({
  consumedByNode,
  node,
  schema,
}: {
  readonly node: Node
  readonly consumedByNode?: Node
} & Pick<Context, 'schema'>): boolean {
  // No target = aggregate query = always singleton
  if (!node.query.target) {
    return true
  }
  // Explicitly requested no unpacking
  if (node.query.noUnpacking) {
    return false
  }
  // Requested as singleton
  if (node.query.quantity === 1) {
    return true
  }
  // All other cases that return as singleton are only applicable when this node
  // is for records and is being consumed by another node for records
  if (
    !ForRecords.isForRecords(node) ||
    !ForRecords.isForRecords(consumedByNode)
  ) {
    return false
  }

  // Ancestors are consumed as singletons because each record can only have
  // one of a given type of ancestor
  if (
    models.Entity.Id.isId(node.source.modelId) &&
    models.Entity.Id.isId(consumedByNode.source.modelId) &&
    schema.isAncestor(node.source.modelId, consumedByNode.source.modelId)
  ) {
    return true
  }

  // TODO: what happens when the connection is through a using node?

  // TODO: Not sure if connection is always needed. Also, this assumes all
  // connection nodes have already been registered, which is not a very safe
  // assumption
  const connectionEdges =
    node.edges.connectedBy.findShortestPathTo(consumedByNode)
  // TODO: not sure if using this node is correct in all cases
  const connectionEdgeToConsumedByNode =
    connectionEdges?.[connectionEdges.length - 1]

  // If the consumer has the reference attribute that connects these
  // queries, and we are not inheriting from ancestors, then the results can
  // be a singleton (e.g. each room can only have one room type, as long as
  // we are not inheriting from ancestors)
  if (
    connectionEdgeToConsumedByNode?.ref &&
    !Inheritance.includesAncestors(
      connectionEdgeToConsumedByNode.ref.inherit,
    ) &&
    models.Entity.Id.from(connectionEdgeToConsumedByNode.ref.attr) ===
      consumedByNode.source.modelId
  ) {
    return true
  }

  // If none of the above cases are met, the result should be a list
  return false
}
